export default "__VITE_ASSET__DP3ynY6$__"